/**
 * 社区消息的状态管理
 */
import ROUTER from '../../router.js'
import { GET, URLS, POST, DELETE, Utils } from '../../utils'
import { types as TipTypes } from './tip'
import { types as LoadingTypes } from './loading'
import { types as LoginTypes } from './login'

export const types = {
  // 消息列表请求
  FETCH_LIST_MESSAGE: 'MESSAGE/FETCH_LIST_MESSAGE',
  GETTER_LIST_MESSAGE: 'MESSAGE/GETTER_LIST_MESSAGE',
  // 点赞回调处理事件
  LOAD_LIKE_EVENT: 'MESSAGE/LOAD_LIKE_EVENT',
  // 删除消息请求
  FETCH_DELETE_MESSAGE: 'MESSAGE/FETCH_DELETE_MESSAGE',
  // 消息删除回调处理事件
  LOAD_DELETE_EVENT: 'MESSAGE/LOAD_DELETE_EVENT'
}

const state = {
  total_count:0,
  data: [], // 数据源列表
  page: 1, // 当前请求页面
  page_size: 10, // 一页请求多少条数据
  load_more: false // 是否还有数据未加载
}

const mutations = {
  set_load_more (state, param) {
    // param: {"value": true, "data_type":"数据源类型"}
    if (param.data_type === types.FETCH_LIST_MESSAGE) {
      state.load_more = param.value
    }
  },
  set_pagenum (state, param) {
    // param: {"value": 3, "data_type":"数据源类型"}
    if (param.data_type === types.FETCH_LIST_MESSAGE) {
      state.page = param.value
    }
  },
  set_list_data (sate, param) {
    // param: {"data": [], "data_type":"数据源类型"}
    if (param.data_type === types.FETCH_LIST_MESSAGE) {
      if (state.page === 1) {
        state.data = param.data
      } else {
        state.data = state.data.concat(param.data)
      }
      state.total_count = param.count
    }
  },
  
  [types.LOAD_LIKE_EVENT] (state, param) {
    let types = []
    if (param.type === 'comment') {
      types = ['create_comment', 'attention_comment']
    } else if (param.type === 'reply') {
      types = ['create_reply', 'attention_reply']
    }
    let target_item = state.data.find((item, index) => {
      return types.includes(item.types) && item.record_data && item.record_data.pk === param.pk
    })
    if(target_item){
      if (target_item['record_data']['is_like'] === false) {
        target_item['record_data']['is_like'] = true
        target_item['record_data']['like_count'] += 1
      } else {
        target_item['record_data']['is_like'] = false
        target_item['record_data']['like_count'] -= 1
      }
    }
  },

  [types.LOAD_DELETE_EVENT] (state, pk) {
    state.data = state.data.filter((item, index) => {
      return item.pk !== pk
    })
  }
}

const actions = {
  /**
   * 消息列表
   * @param {*} param {"page":1, "from":"来源类型"}
   */
  [types.FETCH_LIST_MESSAGE] ({ dispatch, commit, state, rootState, rootGetter }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_MESSAGE }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    let from = param.from;
    let owner = rootState.login.username
    let url = URLS.list_message(state.page)
    if (from === 'receive_comment') {
      // 收到的评论
      url = URLS.list_message(state.page, 'create', 'receiver', owner)
    } else if (from === 'receive_like') {
      // 收到的点赞
      url = URLS.list_message(state.page, 'like', 'receiver', owner)
    } else if (from === 'send_comment') {
      // 发出的评论
      url = URLS.list_message(state.page, 'create', 'sender', owner)
    } else if (from === 'send_like') {
      // 发出的点赞
      url = URLS.list_message(state.page, 'like', 'sender', owner)
    } else if (from === 'notification') {
      // 收到的通知消息
      url = URLS.list_message(state.page, 'notification', 'receiver', owner)
    } else if(from === 'attention_post'){
      // 收到的@社区消息
      url = URLS.list_message(state.page, 'attention_post', 'receiver', owner)
    }else if(from === 'attention_comment'){
      // 收到的@评论和@回复消息
      url = URLS.list_message(state.page, 'comment', 'receiver', owner)
    }

    GET(url).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, 'value': true })
      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })

      // 移除等待动画
      commit(LoadingTypes.HIDE)

      // 更新已读、未读消息数
      dispatch(LoginTypes.FETCH_UNREAD_MESSAGE)
    })
  },

  // 删除消息
  [types.FETCH_DELETE_MESSAGE] ({ dispatch, commit, state, rootState, rootGetter }, pk) {
    DELETE(URLS.delete_message(pk)).then(response => {
      commit(types.LOAD_DELETE_EVENT, pk)
    })
  }

}

const getters = {
  [types.GETTER_LIST_MESSAGE] (state) {
    let data = []
    state.data.map((item, index) => {
      let new_item = Object.assign({}, item)
      new_item['create_time'] = new_item.create_time.slice(0, 19).replace('T', ' ')
      /* content 转义
      if (new_item.record_data) {
        if (new_item.record_data.hasOwnProperty('content')) {
          let content = Utils.formatString(Utils.replaceEmotionString(new_item.record_data.content))
          new_item = { ...new_item, 'record_data': { ...new_item.record_data, 'content': content } }
        }
        if (new_item.record_data.hasOwnProperty('post')) {
          let temp_data = { ...new_item.record_data.post }
          temp_data['content'] = Utils.formatString(Utils.replaceEmotionString(temp_data.content))
          new_item = { ...new_item, 'record_data': { ...new_item.record_data, 'post': temp_data } }
        }
        if (new_item.record_data.hasOwnProperty('comment')) {
          let temp_data = { ...new_item.record_data.comment }
          temp_data['content'] = Utils.formatString(Utils.replaceEmotionString(temp_data.content))
          if (temp_data.hasOwnProperty('post')) {
            let post_data = { ...temp_data.post }
            post_data['content'] = Utils.formatString(Utils.replaceEmotionString(post_data.content))
            temp_data = { ...temp_data, 'post': post_data }
          }
          new_item = { ...new_item, 'record_data': { ...new_item.record_data, 'comment': temp_data } }
        }
        if (new_item.record_data.hasOwnProperty('reply')) {
          let temp_data = { ...new_item.record_data.reply }
          temp_data['content'] = Utils.formatString(Utils.replaceEmotionString(temp_data.content))
          if (temp_data.hasOwnProperty('comment')) {
            let comment_data = { ...temp_data.comment }
            comment_data['content'] = Utils.formatString(Utils.replaceEmotionString(comment_data.content))
            if (comment_data.hasOwnProperty('post')) {
              let post_data = { ...comment_data.post }
              post_data['content'] = Utils.formatString(Utils.replaceEmotionString(post_data.content))
              comment_data = { ...comment_data, 'post': post_data }
            }
            temp_data = { ...temp_data, 'comment': comment_data }
          }
          new_item = { ...new_item, 'record_data': { ...new_item.record_data, 'reply': temp_data } }
        }
      }
      */
      data.push(new_item)
    })
    return data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
